import React, { useState } from 'react'
import { Breadcrumb } from '../../components'
import Form from './form';

function Create() {

  const ListHeader = () => {
    const [activeTab, setActiveTab] = useState("Add Registration");

    return (
      <>
        <div className='d-flex flex-lg-row-fluid'>
          <ul className='nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-8'>
            <li className='nav-item'>
                <button
                    className={`nav-link text-active-primary pb-4 ${activeTab === "Add Registration" ? "active" : ""}`}
                    onClick={() => setActiveTab("Add Registration")}
                >
                    Add Registration
              </button>
            </li>
          </ul>
        </div>
      </>
    )
  }

  return (
    <>
        <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Breadcrumb title={'Home'} header={'Add Registration'}/>
            <div className='app-container container-xxl d-flex'>
                <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                    <div className='d-flex flex-column flex-column-fluid'>
                        <div className='app-content'>
                           <ListHeader />
                           <Form title={'Data Patient'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Create